/**
 * DeviceShot frames a screenshot of the app as a phone: metal rim, black
 * bezel, punch-hole camera, side keys and a sheen on the glass (owner,
 * 2026-10-22: the plain case was "too plain"). Drawn in CSS (`.device` in
 * index.css) so one frame serves every size and both schemes.
 *
 * It takes the day and the night screenshot and shows the one that matches
 * the site's scheme. Both are <img>s toggled by the `dark:` variant rather
 * than a <picture> media query, because the header's sun/moon can override the
 * system and a media query cannot see it. The hidden one is never fetched:
 * browsers skip lazy images that are not displayed.
 */
export default function DeviceShot({
  day,
  night,
  alt,
  eager = false,
  className = "",
}: {
  day: string;
  night: string;
  alt: string;
  eager?: boolean;
  className?: string;
}) {
  const loading = eager ? "eager" : "lazy";
  return (
    <div className={`device ${className}`}>
      <div className="device-body">
        <span className="device-camera" aria-hidden="true" />
        <div className="device-screen">
          <img
            src={day}
            alt={alt}
            width={720}
            height={1395}
            loading={loading}
            className="dark:hidden"
          />
          <img
            src={night}
            alt={alt}
            width={720}
            height={1395}
            loading={loading}
            className="hidden dark:block"
          />
        </div>
      </div>
    </div>
  );
}
